import { jsxs as s, jsx as r } from "react/jsx-runtime";
import "react";
import { classes as o } from "../../utils/helpers.js";
import '../../assets/ImageReplacementAnchor.css';const a = {
  "image-replacement-anchor": "_image-replacement-anchor_hx29b_1",
  "image-replacement-anchor__text": "_image-replacement-anchor__text_hx29b_14"
};
function x({
  href: l = "",
  target: t = "_self",
  image: e = { url: "", width: 1, height: 1, altText: "" },
  text: n = "",
  height: c = 4,
  baselineAdjustment: m = 0,
  classname: i = ""
}) {
  return /* @__PURE__ */ s(
    "a",
    {
      className: o([
        a["image-replacement-anchor"],
        "image-replacement-anchor",
        i
      ]),
      href: l,
      target: t,
      rel: t === "_blank" ? "noreferrer" : null,
      style: {
        "--ira-aspect-ratio": e.width / e.height,
        "--ira-height": `${c}rem`,
        "--ira-baseline-adjustment": `${m}rem`
      },
      children: [
        /* @__PURE__ */ r(
          "img",
          {
            src: e.url,
            className: a["image-replacement-anchor__image"],
            alt: e.altText,
            role: "presentation",
            loading: "lazy"
          }
        ),
        e.altText === "" || e.altText === void 0 ? /* @__PURE__ */ r("span", { className: a["image-replacement-anchor__text"], children: n }) : null
      ]
    }
  );
}
export {
  x as ImageReplacementAnchor,
  x as default
};
